<template>
  <div v-if="!seriesPreselected">
    <FormSection title="">
      <div class="styled-radio-container--ou-donation main-selector">
        <div class="radio-part">
          <input
            id="type_daily"
            type="radio"
            :checked="getValue('custom.sponsorshipType') == 'daily'"
            @click="setValue('custom.sponsorshipType', 'daily')"
          />
          <FormLabel for="type_daily"> Parnes Hayom </FormLabel>
        </div>

        <div class="radio-part">
          <input
            id="type_weekly"
            type="radio"
            :checked="getValue('custom.sponsorshipType') == 'weekly'"
            @click="setValue('custom.sponsorshipType', 'weekly')"
          />
          <FormLabel for="type_weekly"> Weekly Sponsorship </FormLabel>
        </div>

        <!-- <div class="radio-part">
          <input
            id="type_shiur"
            type="radio"
            :checked="getValue('custom.sponsorshipType') == 'series'"
            @click="setValue('custom.sponsorshipType', 'series')"
          />
          <FormLabel for="type_shiur"> Sponsor a Shiur </FormLabel>
        </div> -->
        <div class="radio-part">
          <input
            id="type_gen"
            type="radio"
            :checked="getValue('custom.sponsorshipType') == 'general'"
            @click="setValue('custom.sponsorshipType', 'general')"
          />
          <FormLabel for="type_gen"> General Donation </FormLabel>
        </div>
      </div>
      <ErrorLabel field="custom.sponsorshipType" />
    </FormSection>

    <!-- daily parnes -->
    <template v-if="getValue('custom.sponsorshipType') == 'daily'">
      <div class="donation-type">
        <FormSection title="Donation Date">
          <FormRow inline style="max-width: 50%; margin-bottom: 10px">
            <input
              type="date"
              class="date-input"
              @change="setDailyDate(new Date($event.target.value))"
            />
          </FormRow>
          <div>
            <FormLabel
              >Dedicate a day of learning across the platform -
              <b
                ><MoneyFormat
                  class="label-amount"
                  :value="360"
                  :currencyCode="form.currency || 'USD'"
                  :hide-subunits="true" /></b
            ></FormLabel>
          </div>

          <div><ErrorLabel field="custom.startDate" /></div>
          <div style="margin-bottom: 20px">
            <FormLabel
              >For naming and other special dedications please contact
              <a href="mailto:info@allmishnah.org">info@allmishnah.org</a></FormLabel
            >
          </div>
        </FormSection>
      </div>
    </template>

    <!-- weekly -->
    <template v-else-if="getValue('custom.sponsorshipType') == 'weekly'">
      <div class="donation-type">
        <FormSection title="Donation Date">
          <FormRow inline style="max-width: 50%; margin-bottom: 10px">
            <input
              type="date"
              class="date-input"
              @change="setDate(new Date($event.target.value))"
            />
          </FormRow>
          <div>
            <FormLabel>
              Dedicate a week of learning across the platform.<br />(Dedication will be
              displayed across all series) -
              <b
                ><MoneyFormat
                  class="label-amount"
                  :value="720"
                  :currencyCode="form.currency || 'USD'"
                  :hide-subunits="true" /></b
            ></FormLabel>
          </div>

          <div><ErrorLabel field="custom.startDate" /></div>
          <div style="margin-bottom: 20px">
            <FormLabel
              >For naming and other special dedications please contact
              <a href="mailto:info@allmishnah.org">info@allmishnah.org</a></FormLabel
            >
          </div>
        </FormSection>
      </div>
    </template>

    <!-- series -->
    <template v-else-if="getValue('custom.sponsorshipType') == 'series'">
      <div class="donation-type donation--fancy donation--col">
        <FormRow>
          <FormSelect field="custom.programId" style="flex: 1; margin-right: 10px">
            <option :value="null">Select a Shiur</option>
            <option v-for="shiur of shiurim" :key="shiur.id" :value="shiur.id">
              {{ shiur.name }}
            </option>
          </FormSelect>
        </FormRow>
        <ErrorLabel field="custom.programId" />
        <FormSection title="Donation Amount">
          <!-- regualr amounts -->
          <div class="styled-radio-container--ou-donation type-selector">
            <div class="radio__part">
              <input
                type="radio"
                name="donationShiurType"
                id="donationShiurType-day"
                :checked="donationShiurType == 'day'"
                @click="
                  () => {
                    donationShiurType = 'day';
                  }
                "
              />
              <label for="donationShiurType-day"
                ><b>Day</b>
                <span
                  ><MoneyFormat
                    class="label-amount"
                    :value="118"
                    :currencyCode="form.currency || 'USD'"
                    :hide-subunits="true" /></span
              ></label>
            </div>
            <div class="radio__part">
              <input
                type="radio"
                name="donationShiurType"
                id="donationShiurType-week"
                :checked="donationShiurType == 'week'"
                @click="
                  () => {
                    donationShiurType = 'week';
                  }
                "
              />
              <label for="donationShiurType-week"
                ><b>Week</b>
                <span
                  ><MoneyFormat
                    class="label-amount"
                    :value="500"
                    :currencyCode="form.currency || 'USD'"
                    :hide-subunits="true" /></span
              ></label>
            </div>
            <div class="radio__part">
              <input
                type="radio"
                name="donationShiurType"
                id="donationShiurType-month"
                :checked="donationShiurType == 'month'"
                @click="
                  () => {
                    donationShiurType = 'month';
                  }
                "
              />
              <label for="donationShiurType-month"
                ><b>Month </b>
                <span
                  ><MoneyFormat
                    class="label-amount"
                    :value="1800"
                    :currencyCode="form.currency || 'USD'"
                    :hide-subunits="true" /></span
              ></label>
            </div>
          </div>
        </FormSection>

        <div class="donation-type">
          <FormSection title="Donation Date">
            <FormRow inline style="max-width: 50%; margin-bottom: 10px">
              <input
                type="date"
                class="date-input"
                @change="setDailyDate(new Date($event.target.value))"
                v-if="donationShiurType == 'day'"
              />
              <input
                type="date"
                class="date-input"
                @change="setDate(new Date($event.target.value))"
                v-else-if="donationShiurType == 'week'"
              />
              <input
                type="month"
                class="date-input"
                @change="setMonthDate(new Date($event.target.value))"
                v-else
              />
            </FormRow>
            <ErrorLabel field="custom.startDate" />

            <div style="margin-bottom: 20px">
              <FormLabel
                >For naming and other special dedications please contact
                <a href="mailto:info@allmishnah.org">info@allmishnah.org</a></FormLabel
              >
            </div>
          </FormSection>
        </div>

        <!-- <DatePicker
            v-bind="datepickerOptions"
            placeholder="Select start date"
            @input="setDate($event)"
          />
        <ErrorLabel field="custom.startDate" /> -->
      </div>
    </template>

    <template v-else-if="getValue('custom.sponsorshipType') == 'general'">
      <div class="donation-type general">
        <AmountSelector />
      </div>
    </template>
  </div>
  <div v-else>
    <h1 class="sponsor"><span>Sponsor Series</span>{{ selectedSeries }}</h1>
    <div class="donation-type general">
      <div class="note">$180 donation and above entitles you to a Shiur dedication</div>
      <AmountSelector />
      <FormRow inline style="max-width: 50%" v-if="showDedicationAndDate">
        <input
          type="date"
          class="date-input"
          @change="setDate(new Date($event.target.value))"
        />
      </FormRow>

      <ErrorLabel field="custom.startDate" />
    </div>
  </div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  props: {
    seriesPreselected: Boolean,
    showDedicationAndDate: Boolean,
  },
  setup() {
    const { setValue, getValue, form } = usePaymentForm();

    const shiurim = ref([]);

    const donationShiurType = ref<string | null>(null);

    setValue("custom.sponsorshipType", "daily");
    setValue("custom.dateOption", "Day");

    watch(
      () => getValue("custom.sponsorshipType"),
      () => {
        if (getValue("custom.sponsorshipType") == "weekly") {
          setValue("amount", "720");
          setValue("custom.dateOption", "Week");
        } else if (getValue("custom.sponsorshipType") == "daily") {
          setValue("amount", "360");
          setValue("custom.dateOption", "Day");
        } else {
          setValue("amount", null);
        }

        setValue("custom.programId", null);

        donationShiurType.value = null;

        if (getValue("custom.sponsorshipType") == "general") {
          setValue("custom.startDate", null);
          setValue("custom.endDate", null);
          setValue("custom.dateOption", null);
        }

        if (getValue("custom.sponsorshipType") == "shiur") {
          setValue("custom.startDate", null);
          setValue("custom.endDate", null);
          // setValue("campaign", "All Daf");
        }
      }
    );

    watch(donationShiurType, () => {
      // setValue("custom.programId", null);

      if (donationShiurType.value == "day") {
        setValue("amount", "118");
        setValue("custom.dateOption", "Day");
      }
      if (donationShiurType.value == "week") {
        setValue("amount", "500");
        setValue("custom.dateOption", "Week");
      }
      if (donationShiurType.value == "month") {
        setValue("amount", "1800");
        setValue("custom.dateOption", "Month");
      }
      // if (donationShiurType.value == "shiur") {
      //   setValue("amount", "180");
      // }
    });

    const selectedSeries = computed(() => {
      //@ts-ignore
      const foundSeries = shiurim.value.find((x) => x.id == getValue("custom.programId"));
      //@ts-ignore

      //@ts-ignore
      if (foundSeries) return foundSeries.name;

      return null;
    });

    watch(selectedSeries, (selectedSeries) => {
      setValue("applications.0.subCampaign", selectedSeries);
    });

    onMounted(() => {
      fetch(
        process.env.NODE_ENV == "production"
          ? "https://outorah.org/allMishnahSeries"
          : "https://outorah.oudev.org/allMishnahSeries"
      )
        .then((x) => x.json())
        .then((x) => {
          // Prod returns allMishnaType with underscores, staging with spaces;
          // normalize before filtering.
          x = x.map((item: any) => ({
            ...item,
            allMishnaType: (item.allMishnaType || "").replace(/_/g, " "),
          }));
          shiurim.value = x.filter((x: any) => x.allMishnaType != "Aliya Yomi");
        });
    });

    function setDate(date: Date) {
      setValue(
        "custom.startDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
        ).toISOString()
      );
      setValue(
        "custom.endDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate() + 6)
        ).toISOString()
      );
    }

    function setDailyDate(date: Date) {
      setValue(
        "custom.startDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
        ).toISOString()
      );
      setValue(
        "custom.endDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate() + 1)
        ).toISOString()
      );
    }

    function setMonthDate(date: Date) {
      //needs to be ipdated to first and end of month
      setValue(
        "custom.startDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
        ).toISOString()
      );
      setValue(
        "custom.endDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth() + 1, date.getDate())
        ).toISOString()
      );
    }

    return {
      donationShiurType,
      shiurim,
      form,
      currency: computed(() => form.value.currency),
      getValue,
      setValue,
      setDate,
      setDailyDate,
      setMonthDate,
      selectedSeries,
    };
  },
});
</script>
<style scoped lang="scss">
.styled-radio-container--ou-donation {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  &.type-selector {
    justify-content: center;
    gap: 0px 5px;
  }
  .radio-part {
    padding: 0px 5px;
    line-height: 1;
    @media (max-width: 720px) {
      width: 50%;
      margin-bottom: 10px;
    }
    @media (min-width: 720px) {
      min-width: 33.33333%;
      flex: 1;
      padding-left: 0;
      max-width: 33.33333%;
      margin-bottom: 10px;

      &:nth-child(6n) {
        padding-right: 0;
      }
    }
  }
  input[type="radio"] {
    height: 0;
    top: 20px;
    position: relative;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  ::v-deep label {
    padding: 15px;
    background: #fff;
    line-height: 1.4;
    border: 1px solid #93a9c1;
    color: #2e343c;
    width: 100%;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-top: -15px;
    display: block;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input[type="radio"]:checked + label {
    background: #99badd;
    color: #ffffff;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    input[type="number"] {
      background: #fff;
      margin-top: -15px;
    }
  }
}

//type selector
.type-selector,
.main-selector {
  .radio-part {
    min-width: 33.333%;
    max-width: 33.333%;
    text-transform: uppercase;
    font-size: 13px;
  }
}

//amount selector
.donation-type.general {
  ::v-deep .styled-radio--ou-donation.styled-radio {
    label {
      border: 1px solid #93a9c1;
      color: #2e343c;
      font-weight: normal;
    }
    input[type="radio"]:checked + label {
      background: #99badd;
      color: #ffffff;
    }
  }
}
::v-deep .donation-type.donation--fancy,
::v-deep .type-selector {
  display: flex;
  align-items: center;
  justify-content: center;

  &.donation--col {
    flex-flow: column;
    justify-content: flex-start;
    align-items: baseline;
  }

  .radio__part {
    label {
      display: flex;
      flex-flow: column;
      border: 1px solid #93a9c1;
      cursor: pointer;
      text-align: center;
      border-radius: 4px;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;
      margin-right: 15px;
      flex-flow: column;
      cursor: pointer;
      padding: 2px 18px;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      color: #2e343c;
      font-size: 17px;
      &:hover {
        background: #e9f0f7;
      }
    }
    span {
      font-weight: 200;
    }
    input {
      height: 0;
      top: 20px;
      position: relative;
      left: 20px;
      z-index: -1;
      visibility: hidden;
    }

    input[type="radio"]:checked + label {
      background: #99badd !important;
      color: #ffffff;
    }
  }
}
hr {
  margin-bottom: 20px;
}
::v-deep .money_format {
  display: inline;
}

h1.sponsor {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #efefef;
  letter-spacing: -1px;
  font-size: 28px;
  line-height: 1.4;
  margin-top: 20px;
  span {
    display: block;
    font-size: 14px;
    text-transform: uppercase;
    color: #999;
  }
}
.note {
  margin-bottom: 15px;
  background: #348dff1a;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  border: 1px solid #d8e2ec;
}
.series__type {
  width: 100%;
  margin-bottom: 20px;
  label {
    flex: 1;
  }
}
.date-input {
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: #222;
}
</style>
